export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/node_modules/swiper/esm/components/core/translate/maxTranslate.js
// module id = 58
// module chunks = 0